var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ScaleDataSectionComponent } from 'app/reports/models/scale-list-data-component';
var ScaleResultsSectionsListComponent = /** @class */ (function (_super) {
    __extends(ScaleResultsSectionsListComponent, _super);
    function ScaleResultsSectionsListComponent() {
        return _super.call(this) || this;
    }
    ScaleResultsSectionsListComponent.prototype.getHTMLClassNames = function () {
        return ["scale-results", "report-item-component"];
    };
    ScaleResultsSectionsListComponent.prototype.ngOnInit = function () {
    };
    ScaleResultsSectionsListComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    return ScaleResultsSectionsListComponent;
}(ScaleDataSectionComponent));
export { ScaleResultsSectionsListComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/scale-results-sections-list/scale-results-sections-list.component.ts.pre-build-optimizer.js